import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import IngredientProducts from 'components/desktop/Ingredient/IngredientProducts/IngredientProducts';
import OrderGuideMapping from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/Index';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import ENTITLEMENTS from 'enums/entitlements';
import PERMISSIONS from 'enums/permissions';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

type IProps = IngredientTabProps;

const TabErp = ({ state, handlers }: IProps) => {
	const isIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEINGREDIENT,
	]);

	return (
		<>
			<OrderGuideMapping ingredientId={state.id ?? ''} />
			<RenderIf entitlements={[ENTITLEMENTS.CARBONDIOXIDE]} condition={Boolean(state.id)}>
				<IngredientProducts
					disabled={!isIngredientEditor}
					products={state.products}
					setProducts={handlers.setProducts}
					ingredientId={state.id ?? ''}
				/>
			</RenderIf>
		</>
	);
};

export default TabErp;
